import Vue from 'vue';

import countries from './countries';
import helpers from './helpers';
import i18n from './i18n';
import setup from './setup';
import to from './to';

Vue.mixin(helpers);
Vue.mixin(to);
Vue.mixin(setup);

export { countries, i18n };
